import { render, staticRenderFns } from "./FormularioTerritorioGlebaOperacao.vue?vue&type=template&id=38643b22&lang=pug"
import script from "./FormularioTerritorioGlebaOperacao.vue?vue&type=script&lang=js"
export * from "./FormularioTerritorioGlebaOperacao.vue?vue&type=script&lang=js"
import style0 from "./FormularioTerritorioGlebaOperacao.vue?vue&type=style&index=0&id=38643b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports